import { ResourceAttributeLookupValueInfo } from "./resource-attribute-lookup-info";

export class LookupListItem{
    public id: number;
    public value: string;  
    
    static fromDto(dto: ResourceAttributeLookupValueInfo): LookupListItem {
        let entity = new LookupListItem();
        entity.id = dto.id;
        entity.value = dto.value;
        return entity;
    }
}